export default {
  account: () => import("/var/www/apps/storefront-app/layouts/account.vue").then(m => m.default || m),
  blank: () => import("/var/www/apps/storefront-app/layouts/blank.vue").then(m => m.default || m),
  "checkout-login": () => import("/var/www/apps/storefront-app/layouts/checkout-login.vue").then(m => m.default || m),
  default: () => import("/var/www/apps/storefront-app/layouts/default.vue").then(m => m.default || m),
  "simple-branch-contact": () => import("/var/www/apps/storefront-app/layouts/simple-branch-contact.vue").then(m => m.default || m),
  simple: () => import("/var/www/apps/storefront-app/layouts/simple.vue").then(m => m.default || m),
  types: () => import("/var/www/apps/storefront-app/layouts/types.ts").then(m => m.default || m)
}